"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarningAlert = void 0;
var tslib_1 = require("tslib");
var Alert_1 = require("./Alert");
var useAlert_1 = require("./useAlert");
function useWarningAlert(props) {
    if (props === void 0) { props = tslib_1.__assign(tslib_1.__assign({}, { children: undefined }), { Component: Alert_1.Alert }); }
    var _a = useAlert_1.useAlert(props), warningAlert = _a.alert, setWarningAlert = _a.setAlert;
    return { warningAlert: warningAlert, setWarningAlert: setWarningAlert };
}
exports.useWarningAlert = useWarningAlert;
//# sourceMappingURL=WarningAlert.js.map